export default "__VITE_ASSET__CfN_Mtzb__"